import React from 'react';
import { Grid } from '@nextiva/next-ui-components';
import clsx from 'clsx';

import classes from './m-table-header.scss';

const DomainTableHeader = () => {
  return (
    <div className="m-table-header">
      <Grid container>
        <Grid item xs={6}>
          <span className={clsx('Heading6', classes.header__text)}>
            Domain name
          </span>
        </Grid>
        <Grid item xs={6}>
          <span className={clsx('Heading6', classes.header__text)}>Status</span>
        </Grid>
      </Grid>
    </div>
  );
};

export default DomainTableHeader;
